import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import model               from '@widesk-core/decorators/model';

@doc.path('/site_page_statuses/{?id}')
@model.cacheDuration()
abstract class AbstractSitePageStatusModel extends WebsiteServiceModel {
	declare protected _tsFilters: {
		partial: string;
	};

	@doc.string declare name: string;
	@doc.number declare value: number;
	@doc.string declare label: string;
	@doc.string declare reference: Website_SitePageStatusReference;
}

export default AbstractSitePageStatusModel;
